import React from "react";

import {ILatestQuery} from "../../utils/latest_query";
import {IOfferBox, OfferBox} from "../components/offer_box/OfferBox";
import {useOfferDetailsActions} from "../hooks/use_offer_details_actions";
import {IModalPropertyListOffer} from "../list/components/OfferListPropertiesModal";
import {hitGTMOfferSelectItem} from "../tracking/ecommerce_events/offer/hit_gtm_offer_select_item";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferModalOffer} from "../types/OfferModalOffer";

interface IProps {
    dataTestId?: string;
    offer: IOfferBoxWithPropertiesModalOffer;
    unlinkVendor?: boolean;
    shouldLinkToOffer?: boolean;
    onClick?: () => void;
    index: number;
    titleTag?: React.ElementType;
    latestQuery?: ILatestQuery & Record<string, string | string[] | null>;
    gtmMeta: IOfferBox["gtmMeta"];
    trackAmplitudeSelectItem?: boolean;
}

export type IOfferBoxWithPropertiesModalOffer = IOfferBoxOffer & IModalPropertyListOffer;

export function OfferBoxWithOfferDetailsAction(props: IProps) {
    const {unlinkVendor, gtmMeta, index, offer, dataTestId, latestQuery, onClick, shouldLinkToOffer, titleTag, trackAmplitudeSelectItem} = props;

    const {showOfferDetailsGeneralHandler} = useOfferDetailsActions();

    const handleShowOfferDetailsBtnClick = (offer: IOfferModalOffer) => {
        hitGTMOfferSelectItem({
            offer,
            listId: gtmMeta.listId,
            listName: gtmMeta.listName
        });
        showOfferDetailsGeneralHandler({
            offer,
            latestQuery,
            gtmSource: gtmMeta.source
        });
    };

    return (
        <OfferBox
            offer={offer}
            onShowOfferDetailsBtnClick={handleShowOfferDetailsBtnClick}
            offerDetailsBtnText={offer.configuration.pre_sale ? "Zobacz inwestycję" : undefined}
            unlinkVendor={unlinkVendor}
            shouldLinkToOffer={shouldLinkToOffer}
            onClick={onClick}
            index={index}
            titleTag={titleTag}
            gtmMeta={gtmMeta}
            trackAmplitudeSelectItem={trackAmplitudeSelectItem}
            latestQuery={latestQuery}
            dataTestId={dataTestId}
        />
    );
}
import React from "react";

import {ILatestQuery} from "../../utils/latest_query";
import {IOfferBox, OfferBox} from "../components/offer_box/OfferBox";
import {useOfferDetailsActions} from "../hooks/use_offer_details_actions";
import {IModalPropertyListOffer} from "../list/components/OfferListPropertiesModal";
import {hitGTMOfferSelectItem} from "../tracking/ecommerce_events/offer/hit_gtm_offer_select_item";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferModalOffer} from "../types/OfferModalOffer";

interface IProps {
    dataTestId?: string;
    offer: IOfferBoxWithPropertiesModalOffer;
    unlinkVendor?: boolean;
    shouldLinkToOffer?: boolean;
    onClick?: () => void;
    index: number;
    titleTag?: React.ElementType;
    latestQuery?: ILatestQuery & Record<string, string | string[] | null>;
    gtmMeta: IOfferBox["gtmMeta"];
    trackAmplitudeSelectItem?: boolean;
}

export type IOfferBoxWithPropertiesModalOffer = IOfferBoxOffer & IModalPropertyListOffer;

export function OfferBoxWithOfferDetailsAction(props: IProps) {
    const {unlinkVendor, gtmMeta, index, offer, dataTestId, latestQuery, onClick, shouldLinkToOffer, titleTag, trackAmplitudeSelectItem} = props;

    const {showOfferDetailsGeneralHandler} = useOfferDetailsActions();

    const handleShowOfferDetailsBtnClick = (offer: IOfferModalOffer) => {
        hitGTMOfferSelectItem({
            offer,
            listId: gtmMeta.listId,
            listName: gtmMeta.listName
        });
        showOfferDetailsGeneralHandler({
            offer,
            latestQuery,
            gtmSource: gtmMeta.source
        });
    };

    return (
        <OfferBox
            offer={offer}
            onShowOfferDetailsBtnClick={handleShowOfferDetailsBtnClick}
            offerDetailsBtnText={offer.configuration.pre_sale ? "Zobacz inwestycję" : undefined}
            unlinkVendor={unlinkVendor}
            shouldLinkToOffer={shouldLinkToOffer}
            onClick={onClick}
            index={index}
            titleTag={titleTag}
            gtmMeta={gtmMeta}
            trackAmplitudeSelectItem={trackAmplitudeSelectItem}
            latestQuery={latestQuery}
            dataTestId={dataTestId}
        />
    );
}
